import { BrowserRouter, Routes, Route } from "react-router-dom"
import AuthRouter from './routers/AuthRouter'
import { AuthProvider } from './components/auth/useAuth'
import PrivateAdminRouter from './routers/AdminPrivateRouter'
import AdminRouter from './routers/AdminRouter'
import EmployeePrivateRouter from './routers/EmployeePrivateRouter'
import EmployeeRouter from './routers/EmployeeRouter'
import { useEffect } from "react"
import { msalInstance } from "./components/auth/microsoftAuth"
import { useDispatch } from "react-redux"
import { microsoftLogin } from "./actions/usersActions"

export default function App() {
  const dispatch = useDispatch()
 	useEffect(() => {
		const initMsal = async () => {
			await msalInstance.initialize()
			const response = await msalInstance.handleRedirectPromise()

			if (response && response.idToken) {
				dispatch(microsoftLogin(response.idToken))
			}
		}

		initMsal()
  	}, [])

	return (
		<>
			<BrowserRouter>
				<AuthProvider>
					<Routes>
						<Route path="/admin/*" element={ <PrivateAdminRouter><AdminRouter /></PrivateAdminRouter>} />
						<Route path="/empleado/*" element={ <EmployeePrivateRouter><EmployeeRouter /></EmployeePrivateRouter>} />
						<Route path="*" element={<AuthRouter />}/>
					</Routes>
				</AuthProvider>
			</BrowserRouter>
		</>
	)
}